export const PLATFORM_OWNER = 'platform-owner';
export const MODERATOR = 'moderator';
export const OBSERVER = 'observer';
export const PARTICIPANT = 'participant';
export const CMNTY = 'cmnty';
export const MANAGERS = [PLATFORM_OWNER, MODERATOR];
export const MANAGERS_WITH_CMNTY = [PLATFORM_OWNER, MODERATOR, CMNTY];
export const MANAGERS_WITH_OBSERVERS_AND_CMNTY = [PLATFORM_OWNER, MODERATOR, OBSERVER, CMNTY];
